import { render, staticRenderFns } from "./webpage.vue?vue&type=template&id=58e2c1e2&"
import script from "./webpage.vue?vue&type=script&lang=ts&"
export * from "./webpage.vue?vue&type=script&lang=ts&"
import style0 from "./webpage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports